import React from "react";
import { getAdminContact, sendAdminContact } from "../../actions/contact";
import { connect } from "react-redux";
import { faArrowLeft, faBars, faImage, faPaperPlane, faXmark } from "@fortawesome/free-solid-svg-icons";
import { getIdInUrl, tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";
import AdminItemCtct from "../../components/AdminItemCtct";

class AdminCtct extends React.Component {
    state = {
        menuActive: false,
        opts: [
            {
                type: 'link',
                ttl: "Retourner à la page d'accueil de contact",
                ico: faArrowLeft,
                link: "/admin/tchat",
                action: null,
                col: null
            }
        ],
        form: {
            message: '',
            file: '',
        },
        ip: null,
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        datas: []
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.setState({ip: getIdInUrl()});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.setState({ip: getIdInUrl()});
            }
        }

        if (prevState.ip != this.state.ip) {
            this.props.getAdminContact({ip: this.state.ip});
            this.setState({
                alert: tempAlWait()
            })
        }
        if (this.props.redListAdmCtct != prevProps.redListAdmCtct) {
            this.setState({
                alert: this.props.redListAdmCtct.alert,
                datas: this.props.redListAdmCtct.datas
            })
        }
        if (this.props.redSendAdminCtct != prevProps.redSendAdminCtct) {
            this.setState({
                alert: this.props.redSendAdminCtct.alert,
            })
            setTimeout(() => {
                if (this.props.redSendAdminCtct.isNext) {
                    this.props.getAdminContact({ip: this.state.ip});
                    this.setState({
                        alert: tempAlWait(),
                        form: {
                            message: '',
                            file: '',
                        }
                    })
                }
            }, 1000)
        }
    }

    handleSave(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        });
        this.props.sendAdminContact({
            message: this.state.form.message,
            file: this.state.form.file,
            ip: this.state.ip
        });
    }

    getBase64 = file => {
        return new Promise(resolve => {
            let baseURL = "";

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            }
        })
    }
    
    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                changeAlert={(el) => this.setState({alert: el})}
                active={this.state.menuActive}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Discussion"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                <div className="admintchat">
                    {/** Discussion **/}
                    <div className={`admintchat__discu`}>
                        {
                            this.state.datas
                                .sort((a, b) => {
                                    return new Date(b.date.date) - new Date(a.date.date)
                                })
                                .map((mess, key) => {
                                return <AdminItemCtct data={mess} key={`mess-${key}`} />
                            })
                        }
                    </div>

                    {/** Formulaire **/}
                    <form className="admintchat__form">
                        {/** Image **/}
                        {
                            this.state.form.file != '' &&
                            <div className="admintchat__blogimg">
                                <img src={this.state.form.file} alt="Illustration du message" className="admintchat__formimg" />
                                <button
                                    title="Supprimer l'image"
                                    aria-label="Supprimer l'image"
                                    className="admintchat__formbtndelimg"
                                    onClick={() => {
                                        this.setState(prevState => ({
                                            form: {
                                                ...prevState.form,
                                                file: ''
                                            }
                                        }))
                                    }}
                                >
                                    <FontAwesomeIcon icon={faXmark} />
                                </button> 
                            </div>
                        }
                        <div className="admintchat__formbloc">
                            <textarea
                                placeholder="Votre message..."
                                className="admintchat__input"
                                id="adm-mess"
                                onChange={(el) => {
                                    this.setState(prevState => ({
                                        form: {
                                            ...prevState.form,
                                            message: el.target.value
                                        }
                                    }))
                                }}
                                value={this.state.form.message}
                            ></textarea>
                            {/** Bouton file **/}
                            <label
                                className="admintchat__formlab"
                                title="Importer une image"
                                aria-label="Importer une image"
                                htmlFor="btn-file"
                            >
                                <FontAwesomeIcon icon={faImage} />
                            </label>
                            <input
                                type="file"
                                accept="image/*"
                                style={{display: "none"}}
                                id="btn-file"
                                className="admintchat__forminpfile"
                                onChange={(el) => {
                                this.getBase64(el.target.files[0])
                                    .then(result => {
                                        el.target.files[0]["base64"] = result;

                                        this.setState(
                                            prevState => ({
                                                form: {
                                                    ...prevState.form,
                                                    file: result
                                                }
                                            })
                                        )
                                    })
                                    .catch(err => {console.log(err)})
                                }}  
                            />
                            {/** Bouton sauvegarde **/}
                            <button
                                title="Envoyer le message"
                                aria-label="Envoyer le message"
                                className="admintchat__btnsend"
                                onClick={(el) => this.handleSave(el)}
                            >
                                <FontAwesomeIcon icon={faPaperPlane} />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <Alert alert={this.state.alert}/>
        </main> 
    }
}

const mapStateToProps = state => {
    return {
        redListAdmCtct: state.redListAdmCtct,
        redSendAdminCtct: state.redSendAdminCtct
    }
}

const mapDispatchToProps = {
    getAdminContact,
    sendAdminContact
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCtct);

// todo vérifier input accept que image
// todo ajouter possibilité d'envoyer des vidéos